import React, { useEffect, useState } from 'react';
import * as S from './styles';
import './styles.css';
import {
  compareDateWithToday,
  formatCoin,
  formatCNPJ,
  limitString,
} from '../../utils/functions';

import { WithContext as ReactTags } from 'react-tag-input';

import { IBoleto } from '../../interfaces';
import { useBoletos, useStorage } from '../../hooks';
import Download from '../../assets/download.png';
import DocumentViewer from '../document-viewer';
import { Loading } from '../loading';
import { StyledCheckbox } from '../../styles/lib/checkbox';

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

export const OrderCardBoleto: React.FC<IBoleto> = ({
  boleto,
  isDefault = false,
}) => {
  const {
    emailSendStatus,
    emailGroupSendStatus,
    isSendingEmail,
    base64,
    isLoadingBase64,
    errorsBase64,
    loadBase64,
    downloadBillet,
    sendBilletByEmail,
  } = useBoletos();
  const [isActive, setIsActive] = useState(false);
  const [isActiveGroup, setIsActiveGroup] = useState(false);

  const { getItemOnStorage } = useStorage();
  const currentUser = getItemOnStorage('currentUser');
  const user = JSON.parse(currentUser || '');

  const vendorEmail = user.userEmail;

  const clientEmail =
    boleto?.sClienteEmailFinanceiro || 'E-mail do cliente ausente.';

  const [tags, setTags] = useState<any>([]);

  const [groupTags, setGroupTags] = useState<any>([]);

  const [selectedTitulos, setSelectedTitulos] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleAddition = (tag: any) => {
    setTags([...tags, tag]);
  };

  const handleDrag = (tag: any, currPos: any, newPos: any) => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleDelete = (i: any) => {
    setTags(tags.filter((tag: any, index: any) => index !== i));
  };

  const handleAdditionGroup = (tag: any) => {
    setGroupTags([...groupTags, tag]);
  };

  const handleDragGroup = (tag: any, currPos: any, newPos: any) => {
    const newTags = groupTags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setGroupTags(newTags);
  };

  const handleDeleteGroup = (i: any) => {
    setGroupTags(groupTags.filter((tag: any, index: any) => index !== i));
  };

  const numberCPF_CNPJ = boleto.sClienteCNPJ_CPF ?? '';

  const maskedCPF_CNPJ =
    numberCPF_CNPJ.length !== 11
      ? formatCNPJ(numberCPF_CNPJ)
      : numberCPF_CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

  const openGroupItem = () => {
    const newActive = !isActiveGroup;
    setIsActiveGroup(newActive);
    setIsActive(false);
    if (newActive) {
      const vendorTag = { id: vendorEmail, text: vendorEmail };
      if (
        boleto.listagemBoletosCliente &&
        boleto.listagemBoletosCliente.length > 0
      ) {
        const clientStr =
          boleto.listagemBoletosCliente[0].sClienteEmailFinanceiro || '';
        const clientEmails = clientStr
          .split(';')
          .map((e: string) => e.trim())
          .filter((e: string) => e.length > 0);
        setGroupTags([
          vendorTag,
          ...clientEmails.map((e: string) => ({ id: e, text: e })),
        ]);
      } else {
        setGroupTags([vendorTag]);
      }
    }
  };

  const openSingleItem = () => {
    const newActive = !isActive;
    setIsActive(newActive);
    setIsActiveGroup(false);
    if (newActive) {
      onClickBase64(false);
      const vendorTag = { id: vendorEmail, text: vendorEmail };
      const clientStr = boleto.sClienteEmailFinanceiro || '';
      const clientEmails = clientStr
        .split(';')
        .map((e: string) => e.trim())
        .filter((e: string) => e.length > 0);
      setTags([
        vendorTag,
        ...clientEmails.map((e: string) => ({ id: e, text: e })),
      ]);
    }
  };

  const onClickBase64 = (isActive: boolean) => {
    if (!isActive) {
      const dateEndFormatted = boleto.sTituloDataVencimentoAtual.split(' ')[0];
      loadBase64({
        dateStart: '01/01/2023',
        dateEnd: dateEndFormatted,
        tituloNumero: boleto.sTituloNumero,
        numeroParcela: boleto.sTituloSeqVencto,
      });
    }
  };

  const downloadBase64 = (base64: string) => {
    if (!base64 || base64.length === 0) return;

    downloadBillet(base64 ?? '', 'boleto.pdf');
  };

  const handleSelectAll = () => {
    if (!boleto.listagemBoletosCliente) return;
    if (selectAll) {
      setSelectedTitulos([]);
      setSelectAll(false);
    } else {
      const allTitulos = boleto.listagemBoletosCliente.map(
        (elm: any) => elm.sTituloNumero,
      );
      setSelectedTitulos(allTitulos);
      setSelectAll(true);
    }
  };

  const handleSelectTitulo = (sTituloNumero: string) => {
    let newSelected: string[] = [];
    if (selectedTitulos.includes(sTituloNumero)) {
      newSelected = selectedTitulos.filter(num => num !== sTituloNumero);
    } else {
      newSelected = [...selectedTitulos, sTituloNumero];
    }
    setSelectedTitulos(newSelected);
    if (
      boleto.listagemBoletosCliente &&
      newSelected.length === boleto.listagemBoletosCliente.length
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const empresaNumeroGroup = parseInt(
    (boleto.listagemBoletosCliente &&
      boleto.listagemBoletosCliente.length > 0 &&
      boleto.listagemBoletosCliente[0].sEmpresaNumero) ||
      '0',
    10,
  );

  const empresaNumeroSingle = 0;
  const isMobile = window.innerWidth <= 768;
  return (
    <>
      {isDefault ? (
        <S.TabsRow
          className={`show ${isActiveGroup ? 'active activeScale' : ''}`}
        >
          <S.TabsData
            className="start"
            data-label="Cliente"
            onClick={openGroupItem}
          >
            {limitString(boleto.clienteNome ?? '')}
          </S.TabsData>

          <S.TabsData data-label="A vencer" onClick={openGroupItem}>
            {formatCoin(
              parseFloat(boleto.somaValorAVencer ?? '0')
                .toFixed(2)
                .replace('.', ','),
            )}
          </S.TabsData>

          <S.TabsData data-label="Vencido" onClick={openGroupItem}>
            {formatCoin(
              parseFloat(boleto.somaValorVencido ?? '0')
                .toFixed(2)
                .replace('.', ','),
            )}
          </S.TabsData>

          <S.TabsData data-label="Total" onClick={openGroupItem}>
            {formatCoin(
              parseFloat(boleto.somaValorOriginal ?? '0')
                .toFixed(2)
                .replace('.', ','),
            )}
          </S.TabsData>

          <S.TabsData data-label="CPF / CNPJ" onClick={openGroupItem}>
            {maskedCPF_CNPJ}
          </S.TabsData>
        </S.TabsRow>
      ) : (
        <S.TabsRow
          className={`show ${isActive ? 'active' : ''}`}
          onClick={() => onClickBase64(isActive)}
        >
          <S.TabsData
            className="start"
            data-label="Cliente"
            onClick={openSingleItem}
          >
            {limitString(boleto.sClienteNome ?? '')}
          </S.TabsData>

          <S.TabsData data-label="Vencimento" onClick={openSingleItem}>
            {boleto?.sTituloDataVencimentoAtual?.slice(0, 10) ?? ''}
          </S.TabsData>

          <S.TabsData data-label="Título" onClick={openSingleItem}>
            {boleto.sTituloNumero ?? ''}
          </S.TabsData>

          <S.TabsData data-label="Parcela" onClick={openSingleItem}>
            {boleto.sTituloSeqVencto ?? '0'}
          </S.TabsData>

          <S.TabsData data-label="Valor" onClick={openSingleItem}>
            {formatCoin(boleto.sTituloValorOriginal ?? '')}
          </S.TabsData>

          <S.TabsData data-label="CPF / CNPJ" onClick={openSingleItem}>
            {maskedCPF_CNPJ}
          </S.TabsData>

          <S.TabsData
            onClick={() => downloadBase64(base64)}
            data-label="Download"
          >
            <S.TabDownload
              onClick={() => downloadBase64(base64)}
              src={Download}
            />
          </S.TabsData>
        </S.TabsRow>
      )}

      <S.TabsRowForm className={isActive ? 'show active' : ''}>
        <S.TabsDataForm colSpan={isDefault ? 3 : 5}>
          <S.FileView>
            {!isLoadingBase64 && base64 && (
              <DocumentViewer base64Data={base64} />
            )}

            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
              }}
            >
              {isLoadingBase64 && <Loading />}
            </div>

            {!isLoadingBase64 && !base64 && (
              <S.MissingDoc>
                O título selecionado ainda não está disponível em nosso sistema!
                Por favor, tente novamente mais tarde.
              </S.MissingDoc>
            )}
          </S.FileView>
        </S.TabsDataForm>

        <S.TabsDataForm colSpan={2} className="limited-area">
          <S.TitleSend>E-mails para envio:</S.TitleSend>
          <S.SubitleSend>
            (por motivos de segurança, use o domínio da empresa)
          </S.SubitleSend>

          <ReactTags
            tags={tags}
            handleDelete={handleDelete}
            handleAddition={handleAddition}
            handleDrag={handleDrag}
            delimiters={delimiters}
            placeholder="Digite aqui os emails..."
            autofocus={false}
            inputFieldPosition="inline"
            autocomplete
            readOnly
          />

          <S.ButtonSend
            onClick={() =>
              sendBilletByEmail({
                emailList: tags.map((elm: any) => elm.text),
                boleto,
                notesList: boleto.sTituloNumero ? [boleto.sTituloNumero] : [],
                empresaNumero: empresaNumeroSingle,
              })
            }
            disabled={isSendingEmail || !boleto.sClienteEmailFinanceiro}
            className={
              tags.length === 0 || !boleto.sClienteEmailFinanceiro
                ? 'disabled'
                : ''
            }
            type="submit"
          >
            {isSendingEmail ? 'Enviando...' : 'Enviar 2ª Via'}
          </S.ButtonSend>

          {emailSendStatus === 'error' && (
            <S.ErrorMessage>Erro ao enviar</S.ErrorMessage>
          )}

          {emailSendStatus === 'success' && (
            <S.SuccessMessage>E-mail enviado</S.SuccessMessage>
          )}
        </S.TabsDataForm>
      </S.TabsRowForm>

      {boleto.listagemBoletosCliente && (
        <S.TabsRowForm className={isActiveGroup ? 'show active' : ''}>
          {boleto.listagemBoletosCliente && (
            <S.TabsDataForm colSpan={isDefault ? 3 : 5}>
              <S.GroupView>
                <S.GroupItem>
                  <div
                    title="Selecionar todas as notas"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <StyledCheckbox
                      type="checkbox"
                      id="notes"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    <S.HideOnMobile>Todas</S.HideOnMobile>
                  </div>
                </S.GroupItem>
                <S.GroupItem>
                  <div>Vencimento</div>
                </S.GroupItem>
                <S.GroupItem>
                  <div>{isMobile ? 'NF' : 'Nota Fiscal'}</div>
                </S.GroupItem>
                <S.GroupItem>
                  <div>Parcela</div>
                </S.GroupItem>
                <S.GroupItem>
                  <div>Valor</div>
                </S.GroupItem>
              </S.GroupView>
              {boleto.listagemBoletosCliente.map((elm: any, index: number) => {
                const checked = selectedTitulos.includes(elm.sTituloNumero);
                return (
                  <React.Fragment key={index}>
                    <S.GroupView>
                      <S.GroupItem>
                        <div>
                          <StyledCheckbox
                            type="checkbox"
                            id={`notes-${elm.id}`}
                            value={elm.sTituloNumero}
                            checked={checked}
                            onChange={() =>
                              handleSelectTitulo(elm.sTituloNumero)
                            }
                          />
                        </div>
                      </S.GroupItem>
                      <S.GroupItem>
                        <div
                          className={
                            compareDateWithToday(
                              elm?.sTituloDataVencimentoAtual?.slice(0, 10),
                            ) === 'menor'
                              ? 'red'
                              : ''
                          }
                        >
                          {elm?.sTituloDataVencimentoAtual?.slice(0, 10) ?? ''}
                        </div>
                      </S.GroupItem>
                      <S.GroupItem>
                        <div
                          className={
                            compareDateWithToday(
                              elm?.sTituloDataVencimentoAtual?.slice(0, 10),
                            ) === 'menor'
                              ? 'red'
                              : ''
                          }
                        >
                          {elm?.sTituloNumero ?? ''}
                        </div>
                      </S.GroupItem>
                      <S.GroupItem>
                        <div
                          className={
                            compareDateWithToday(
                              elm?.sTituloDataVencimentoAtual?.slice(0, 10),
                            ) === 'menor'
                              ? 'red'
                              : ''
                          }
                        >
                          {elm?.sTituloSeqVencto ?? '0'}
                        </div>
                      </S.GroupItem>
                      <S.GroupItem>
                        <div
                          className={
                            compareDateWithToday(
                              elm?.sTituloDataVencimentoAtual?.slice(0, 10),
                            ) === 'menor'
                              ? 'red'
                              : ''
                          }
                        >
                          {formatCoin(elm?.sTituloValorOriginal ?? '')}
                        </div>
                      </S.GroupItem>
                    </S.GroupView>
                  </React.Fragment>
                );
              })}
            </S.TabsDataForm>
          )}
          <S.TabsDataForm colSpan={2} className="limited-area">
            <S.TitleSend>E-mails para envio:</S.TitleSend>
            <S.SubitleSend>
              (por motivos de segurança, use o domínio da empresa)
            </S.SubitleSend>
            <ReactTags
              tags={groupTags}
              handleDelete={handleDeleteGroup}
              handleAddition={handleAdditionGroup}
              handleDrag={handleDragGroup}
              delimiters={delimiters}
              placeholder="Digite aqui os e-mails..."
              autofocus={false}
              inputFieldPosition="inline"
              autocomplete
              readOnly
            />
            <S.ButtonSend
              onClick={() =>
                sendBilletByEmail({
                  emailList: groupTags.map((elm: any) => elm.text),
                  boleto,
                  notesList: selectedTitulos,
                  empresaNumero: empresaNumeroGroup,
                })
              }
              disabled={
                isSendingEmail ||
                !boleto.listagemBoletosCliente[0].sClienteEmailFinanceiro ||
                selectedTitulos.length === 0
              }
              className={
                groupTags.length === 0 ||
                isSendingEmail ||
                !boleto.listagemBoletosCliente[0].sClienteEmailFinanceiro ||
                selectedTitulos.length === 0
                  ? 'disabled'
                  : ''
              }
              type="submit"
            >
              {isSendingEmail ? 'Enviando...' : 'Enviar 2ª Via'}
            </S.ButtonSend>
            {emailGroupSendStatus && (
              <S.Message>{emailGroupSendStatus}</S.Message>
            )}
          </S.TabsDataForm>
        </S.TabsRowForm>
      )}
    </>
  );
};
